var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M126.2,155.5l-21.7,0.1c-20.3,0.2-36.6,16.7-36.6,37.1v47.7h-30v-61.8l-5.4,0.2c-3.8,0-6.7-1-8.9-3 c-2.4-2.2-3.8-5.4-3.8-8.6v-54.7c0-16.9,13.7-30.6,30.6-30.6h1.4l11.8,55.1l8.8,33l9-32.4l11.4-49.6l0.3-1.1l1.1-4.9 c0.3,0,0.6,0,0.9,0l0.1,0h0.1c0.2,0,0.4,0,0.5,0l0.4,0c0.1,0,0.3,0,0.4,0l0.1,0h0.1c0.2,0,0.3,0,0.5,0.1h0.1l0,0 c8.5,0.9,16.4,5.6,21.5,12.8c-12.7,3.9-21.9,15.7-21.9,29.6C96.9,141.1,109.9,154.6,126.2,155.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "128.1,104 128.1,104 128.1,101  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "128,155.5 128,155.5 131,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F68F6F",
    points: "77.2,98.1 81.4,137.5 72.4,169.9 72.4,169.9 72.4,169.9 63.5,136.9 67.7,98.1 64.9,90.4  62.8,84.5 82.1,84.5 80,90.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M72.5,78.3c-17.3,0-31.3-14.1-31.3-31.3s14.1-31.3,31.3-31.3s31.3,14.1,31.3,31.3S89.7,78.3,72.5,78.3z  M72.5,18.7c-15.6,0-28.3,12.7-28.3,28.3s12.7,28.3,28.3,28.3s28.3-12.7,28.3-28.3S88.1,18.7,72.5,18.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD552",
    d: "M72.5,71.5C59,71.5,48,60.5,48,47s11-24.5,24.5-24.5S97,33.5,97,47S86,71.5,72.5,71.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M32.5,185.4c-5.4,0-9.9-1.6-13.4-4.7c-3.7-3.4-6-8.4-6-13.5v-54.7c0-20.5,16.7-37.2,37.2-37.2h43.5 c0.5,0,1.1,0,1.6,0c0.2,0,0.5,0,0.8,0l0.3,0c0.2,0,0.5,0,0.7,0.1c0.2,0,0.5,0,0.8,0.1c11.1,1.2,21.4,7.7,27.4,17.4 c0.1,0.2,0.3,0.4,0.4,0.7l-2.7,1.4c-0.1-0.2-0.2-0.3-0.3-0.5c-5.6-8.9-15-14.9-25.2-16c-0.3,0-0.5-0.1-0.8-0.1 c-0.3,0-0.5,0-0.6-0.1l-0.3,0c-0.2,0-0.5,0-0.7,0c-0.5,0-1,0-1.5,0H50.4c-18.8,0-34.1,15.3-34.1,34.1v54.7c0,4.2,1.9,8.4,5,11.2 c2.9,2.6,6.7,3.9,11.3,3.9V185.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "128,155.5 128,155.5 131,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 141.1,
    fill: "#4A555F",
    width: 3,
    height: 99.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "128,155.5 128,155.5 131,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M78.4,99.7H66.6L60.7,83h23.6L78.4,99.7z M68.7,96.6h7.5L80,86H65L68.7,96.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "79.9,137.7 75.9,99.7 69,99.7 65,137.1 62,136.8 66.3,96.6 78.7,96.6 82.9,137.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M55.3,105.8l-6.5-30.5h12.4l5.4,15.4L55.3,105.8z M52.5,78.3l4.4,20.3l6.3-8.5L59,78.3H52.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M90.1,106.6L78.4,90.7l5.4-15.4h13.4L90.1,106.6z M81.8,90.2l6.8,9.3l4.8-21.1H86L81.8,90.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M73.8,170.4l-2.9,0l-8.8-33L49.1,77.1l1.5-1.8h44.7l1.5,1.9l-13.9,60.7L73.8,170.4z M52.5,78.3L65,136.6 l7.4,27.6l7.5-27.1l13.5-58.8H52.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M129.7,155.5l21.7,0.1c20.3,0.2,36.6,16.7,36.6,37.1v47.7h30v-61.8l5.4,0.2c3.8,0,6.7-1,8.9-3 c2.4-2.2,3.8-5.4,3.8-8.6v-54.7c0-16.9-13.7-30.6-30.6-30.6h-1.4l-11.8,55.1l-8.8,33l-9-32.4l-11.4-49.6l-0.3-1.1l-1.1-4.9 c-0.3,0-0.6,0-0.9,0l-0.1,0h-0.1c-0.2,0-0.4,0-0.5,0l-0.4,0c-0.1,0-0.3,0-0.4,0l-0.1,0h-0.1c-0.2,0-0.3,0-0.5,0.1h-0.1l0,0 C150,83,142.1,87.7,137,94.9c12.7,3.9,21.9,15.7,21.9,29.6C158.9,141.1,146,154.6,129.7,155.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "127.8,104 127.8,104 127.8,101  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "127.9,155.5 124.9,155.5 127.9,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F68F6F",
    points: "178.7,98.1 174.5,137.5 183.5,169.9 183.5,169.9 183.5,169.9 192.3,136.9 188.2,98.1 191,90.4  193,84.5 173.8,84.5 175.9,90.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M183.4,78.3c-17.3,0-31.3-14.1-31.3-31.3c0-17.3,14.1-31.3,31.3-31.3s31.3,14.1,31.3,31.3 S200.7,78.3,183.4,78.3z M183.4,18.7c-15.6,0-28.3,12.7-28.3,28.3c0,15.6,12.7,28.3,28.3,28.3s28.3-12.7,28.3-28.3 S199,18.7,183.4,18.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD552",
    d: "M183.4,71.5c13.5,0,24.5-11,24.5-24.5s-11-24.5-24.5-24.5c-13.5,0-24.5,11-24.5,24.5 S169.9,71.5,183.4,71.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M223.4,185.4v-3c4.6,0,8.5-1.3,11.3-3.9c3.1-2.8,5-7,5-11.2v-54.7c0-18.8-15.3-34.1-34.1-34.1H162 c-0.5,0-1,0-1.4,0c-0.3,0-0.5,0-0.8,0l-0.3,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6,0.1-0.8,0.1c-10.2,1.1-19.6,7.1-25.2,16 c-0.1,0.2-0.2,0.3-0.3,0.5l-2.7-1.4c0.1-0.2,0.3-0.5,0.4-0.7c6.1-9.7,16.3-16.2,27.4-17.4c0.3,0,0.6-0.1,0.9-0.1 c0.1,0,0.4,0,0.6-0.1l0.3,0c0.3,0,0.6,0,0.9,0c0.5,0,1,0,1.6,0h43.5c20.5,0,37.2,16.7,37.2,37.2v54.7c0,5-2.2,10.1-6,13.5 C233.3,183.8,228.8,185.4,223.4,185.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "127.9,155.5 124.9,155.5 127.9,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.9,
    y: 141.1,
    fill: "#4A555F",
    width: 3,
    height: 99.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "127.9,155.5 124.9,155.5 127.9,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M189.3,99.7h-11.8L171.6,83h23.6L189.3,99.7z M179.7,96.6h7.5l3.7-10.6h-15L179.7,96.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "176,137.7 173,137.4 177.2,96.6 189.6,96.6 193.9,136.8 190.8,137.1 186.9,99.7 180,99.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M200.6,105.8l-11.3-15.1l5.4-15.4h12.4L200.6,105.8z M192.7,90.2l6.3,8.5l4.4-20.3h-6.5L192.7,90.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M165.8,106.6l-7.2-31.3h13.4l5.4,15.4L165.8,106.6z M162.4,78.3l4.8,21.1l6.8-9.3l-4.2-11.8H162.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M182,170.4l-9-32.4l-14-60.8l1.5-1.9h44.7l1.5,1.8l-12.9,60.1l-8.9,33.1L182,170.4z M162.4,78.3 l13.5,58.9l7.5,27l7.4-27.6l12.5-58.2H162.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M183.1,192.6v47.3h-50l18.1-80.1h2.2l0.2,0C170.1,161.6,183.1,176,183.1,192.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M126,239.9H72.4v-47.3c0-16.6,13-31,29.5-32.8l0.2,0h5.8L126,239.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F68F6F",
    points: "137.2,218.7 132.3,240 123.4,240 118.6,218 122.9,177.7 120.1,169.7 118.7,165.8 137.1,165.8  135.7,169.7 132.9,177.7 132.9,177.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M127.9,157c-17.9,0-32.5-14.6-32.5-32.5S110,92,127.9,92c17.9,0,32.5,14.6,32.5,32.5 S145.9,157,127.9,157z M127.9,95.1c-7.9,0-15.3,3.1-20.8,8.6c-5.6,5.6-8.6,13-8.6,20.8c0,16.2,13.2,29.5,29.5,29.5 c16.2,0,29.5-13.2,29.5-29.5S144.2,95.1,127.9,95.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD552",
    d: "M127.9,150.5c-14.3,0-25.9-11.6-25.9-25.9s11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9 S142.2,150.5,127.9,150.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M188.7,239.9h-3v-47.3c0-19.1-14.9-34.7-34-35.5c-0.5,0-1,0-1.5,0H105c-19.6,0-35.6,15.9-35.6,35.6v47.3 h-3v-47.3c0-21.3,17.3-38.6,38.6-38.6h45.2c0.6,0,1.1,0,1.7,0c20.7,0.9,36.9,17.8,36.9,38.6V239.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M134,179.2h-12.2l-5.3-14.9h22.7L134,179.2z M124,176.2h7.9l3.1-8.8h-14.1L124,176.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "135.7,218.8 131.6,179.2 124.3,179.2 120.2,218.2 117.1,217.9 121.6,176.2 134.3,176.2  138.7,218.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M110.1,185.5l-6.8-31.5h12.8l5.6,15.9L110.1,185.5z M107.1,157l4.6,21.3l6.7-8.9L114,157H107.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M146.2,186.3l-12.1-16.4l5.6-15.9h13.8L146.2,186.3z M137.5,169.4l7.2,9.8l5.1-22.1h-7.9L137.5,169.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "133.8,240.3 130.8,239.6 149.8,157.1 107.1,157.1 124.8,239.7 121.9,240.3 103.7,155.9  105.2,154 151.7,154 152.9,155.6 153.2,155.6 153.2,155.9 153.2,155.9 153.2,155.9 146.9,183.1  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 91.2,
    y: 231.7,
    fill: "#4A555F",
    width: 3,
    height: 8.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 231.7,
    fill: "#4A555F",
    width: 3,
    height: 8.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "125.7,155.5 125.7,155.5 128.8,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "132.3,181.1 132.1,180.9 133,180 133.9,178.6 134.2,178.8 133.3,179.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "125.7,155.5 125.7,155.5 128.8,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "132.3,181.1 132.1,180.9 133,180 133.9,178.6 134.2,178.8 133.3,179.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "125.7,155.5 125.7,155.5 128.8,155.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#4A555F",
    points: "132.3,181.1 132.1,180.9 133,180 133.9,178.6 134.2,178.8 133.3,179.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4A555F",
    d: "M128,193.7c-34,0-65.9-4.8-90-13.5c-24.5-8.9-38-20.9-38-33.8c0-7.7,4.6-14.9,13.8-21.6l1.8,2.5 C7.3,133.4,3,139.8,3,146.5c0,11.4,13.1,22.6,36,30.9c23.7,8.6,55.3,13.3,88.9,13.3s65.2-4.7,88.9-13.3c22.9-8.3,36-19.5,36-30.9 c0-6.3-3.8-12.4-11.3-18.2l1.9-2.4c8.3,6.4,12.5,13.3,12.5,20.6c0,12.9-13.5,24.9-38,33.8C193.9,188.9,162,193.7,128,193.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/S1.5613b2e4777305fc13323c22afffae87.svg";
export { ForwardRef as ReactComponent };